<!-- =========================================================================================
    File Name: ApexCharts.vue
    Description: Apex Charts Demo
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="extra-component-chartist-demo">
    <div class="vx-row">
      <!-- LINE AREA CHART -->
      <div class="vx-col  w-full mb-base">
        <vx-card title="Weight (Kg)" subtitle="Distribution">
          <vue-apex-charts
            type="area"
            height="350"
            :options="apexChatData.lineAreaChartSpline.chartOptions"
            :series="apexChatData.lineAreaChartSpline.series"
          ></vue-apex-charts>
        </vx-card>
      </div>
      <!-- SCATTER CHART -->
      <!-- <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Scatter Chart">
          <vue-apex-charts
            type="scatter"
            height="350"
            :options="apexChatData.scatterChart.chartOptions"
            :series="apexChatData.scatterChart.series"
          ></vue-apex-charts>
        </vx-card>
      </div> -->

      <!-- line CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Weight change over time">
          <vue-apex-charts
            type="line"
            height="700"
            :options="apexChatData.lineChartSimpleWeight.chartOptions"
            :series="apexChatData.lineChartSimpleWeight.series"
          ></vue-apex-charts>
        </vx-card>
      </div>

      <!-- line CHART -->
      <div class="vx-col md:w-1/2 w-full mb-base">
        <vx-card title="Percent change over time">
          <vue-apex-charts
            type="line"
            height="700"
            :options="apexChatData.lineChartSimpleWeight.chartOptions"
            :series="lineChartSimplePercentSeries"
          ></vue-apex-charts>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import apexChatData from "./apexChartData.js";

export default {
  data() {
    return {
      apexChatData,
      lineChartSimplePercentSeries: []
    };
  },
  components: {
    VueApexCharts
  },
  mounted() {
    const arr = this.apexChatData.lineChartSimpleWeight.series;
    for (let index = 0; index < arr.length; index++) {
      const series = arr[index].data;
      const tempData = [];

      for (let i = series.length - 1; i >= 0; i--) {
        const chg =
          ((series[i] - series[series.length - 1]) /
            series[series.length - 1]) *
          100;

        tempData.push(Number(chg.toPrecision(2)));
      }
      this.lineChartSimplePercentSeries.push({
        name: arr[index].name,
        data: tempData
      });
    }
  }
};
</script>
